import { SplitPaymentStatus } from "../types/splitPayment";

export const SPLIT_PAYMENTS_COLLECTION = "splitPayments";

export const SPLIT_PAYMENT_STATUS_LABELS: Record<SplitPaymentStatus, string> = {
  [SplitPaymentStatus.PENDING]: "Pendente",
  [SplitPaymentStatus.PROCESSING]: "Processando",
  [SplitPaymentStatus.COMPLETED]: "Pago",
  [SplitPaymentStatus.FAILED]: "Falhou",
  [SplitPaymentStatus.CANCELED]: "Cancelado",
  [SplitPaymentStatus.OVERDUE]: "Atrasado",
};

export const SPLIT_PAYMENT_STATUS_COLORS: Record<SplitPaymentStatus, string> = {
  [SplitPaymentStatus.PENDING]: "bg-yellow-100 text-yellow-700",
  [SplitPaymentStatus.PROCESSING]: "bg-blue-100 text-blue-700",
  [SplitPaymentStatus.COMPLETED]: "bg-green-100 text-green-700",
  [SplitPaymentStatus.FAILED]: "bg-red-100 text-red-700",
  [SplitPaymentStatus.CANCELED]: "bg-gray-100 text-gray-600",
  [SplitPaymentStatus.OVERDUE]: "bg-orange-100 text-orange-700",
};
